import { showExpirationInsteadOfEndDate, expirationDisplayToEndDate } from 'core/helpers/expiration-date';

/**
 * Stored `endDate` to send to the backend, derived from the Settings form values.
 *
 * When the brand shows the EXPIRATION date (#32070), the Settings "Policy Expiration Date" field
 * holds expiration (= stored endDate + 1) for an in-force policy, so it is shifted back by a day
 * on save. A flat cancellation (endDate === effectiveDate, never in force) is never shifted.
 *
 * #36160: once a cancellation is in progress, the cancellation form owns `endDate` and writes it
 * in STORED form (cancelEffectiveDate − 1, or the full-term endDate for branch-initiated reasons),
 * so the shift must not be applied a second time — on CFM/Forreston it saved endDate = D − 2 and
 * collapsed a day-3 cancellation into a flat cancel. `cancel` is set by the Cancel Policy button;
 * `cancelEffectiveDate` (insured-requested reasons) and `transactionDate` (branch-initiated/ODEN
 * reasons) are only ever set by the cancellation form — neither is selected by any staff-fe policy
 * query, so they can't be seeded from the stored policy — and together they also cover the path
 * where staff shorten the expiration field directly (cancel stays false) and then pick a reason.
 */
export const endDateValue = (values) => {
  if (values.reinstateDate) {
    return values.reinstateDate;
  }
  const cancellationFormOwnsEndDate = Boolean(values.cancel || values.cancelEffectiveDate || values.transactionDate);
  if (
    showExpirationInsteadOfEndDate() &&
    !cancellationFormOwnsEndDate &&
    values.endDate &&
    values.endDate !== values.effectiveDate
  ) {
    return expirationDisplayToEndDate(values.endDate);
  }
  return values.endDate;
};
